export default __webpack_public_path__ + "media/components/Pages/Index/Images/ballon-26fc5b1ded26420a3e277b3caade5160.png";